<div class="loyalty-score-container" [ngClass]="containerClass()">
  <svg class="loyalty-score-ring" [attr.width]="30" [attr.height]="24">
    <!-- Background Circle -->
    <circle
            class="loyalty-score-ring__background"
            [attr.cx]="12 + sizeConstant()"
            [attr.cy]="12"
            [attr.r]="radius"
            [attr.stroke]="backgroundColor()"
            [attr.stroke-width]="strokeWidth"
    ></circle>

    <!-- Foreground Circle (loyalty) -->
    <circle
            class="loyalty-score-ring__progress"
            [attr.cx]="12 + sizeConstant()"
            [attr.cy]="12"
            [attr.r]="radius"
            [attr.stroke]="loyaltyColor()"
            [attr.stroke-width]="strokeWidth"
            [attr.stroke-dasharray]="circumference"
            [attr.stroke-dashoffset]="strokeDashoffset()"
    ></circle>
  </svg>
</div>
